
import { Component, Prop, Vue } from "vue-property-decorator";
import CiCheckbox from "@components/base/forms/checkbox.vue";

@Component({
  name: "ci-ais-sfdr-refinement-list",
  components: {
    CiCheckbox,
  },
})
export default class extends Vue {
  @Prop({ required: true }) public attribute!: string;

  public isRefined(value: "article_8" | "article_9", items: { value: string; isRefined: true }[]): boolean {
    return !!items.find((item) => item.value === value)?.isRefined;
  }
}
